"use client";
import { ContactUsAPI } from "@/lib/http";
import { useRouter } from "next/navigation";
import React, { useRef, useState } from "react";
import { BiSolidPaperPlane } from "react-icons/bi";
const ContactForm = ({ btnText }: { btnText?: string }) => {
  const router = useRouter();
  const formRef = useRef<HTMLFormElement>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (loading) return; // ⛔ Prevent double submit
    setLoading(true);
    const formData = new FormData(e.currentTarget);
    const values = Object.fromEntries(formData.entries());
    try {
      const data = await ContactUsAPI.api("post", { data: values });
      if (data?.status === 200) {
        if (data.data?.Status === "success") {
          formRef.current?.reset();
          router.push("/thank-you");
        } else {
          console.error("Error submitting feedback:", data.data?.message);
        }
      }
    } catch (error: any) {
      console.error("Error submitting feedback:", error);
    } finally {
      setLoading(false); // 🔓 Re-enable button
    }
  };
  return (
    <form ref={formRef} onSubmit={onSubmit}>
      <div className="grid md:grid-cols-2 gap-6">
        {/* First Name */}
        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">
            First Name <sup className="text-red-500">*</sup>
          </label>
          <input
            name="FirstName"
            type="text"
            required
            className="w-full border bg-white border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500 outline-none"
          />
        </div>

        {/* Last Name */}
        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">
            Last Name
          </label>
          <input
            name="LastName"
            type="text"
            className="w-full border bg-white border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500 outline-none"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">
            Email <sup className="text-red-500">*</sup>
          </label>
          <input
            name="EmailID"
            type="email"
            required
            className="w-full border bg-white border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500 outline-none"
          />
        </div>

        {/* Mobile */}
        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">
            Mobile Number
          </label>
          <input
            name="MobileNo"
            type="text"
            className="w-full border bg-white border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500 outline-none"
            maxLength={10}
            onInput={(e: React.FormEvent<HTMLInputElement>) => {
              const input = e.currentTarget;
              input.value = input.value.replace(/\D/g, "").slice(0, 10);
            }}
          />
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-600 mb-1">
            Message
          </label>
          <textarea
            name="Message"
            rows={4}
            className="w-full border bg-white border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500 outline-none"
          ></textarea>
        </div>
      </div>
      <div className="flex justify-center">
        <button
          type="submit"
          disabled={loading}
          className={`border w-auto mt-6 py-3 px-6 rounded-full font-semibold flex items-center justify-center gap-2
                  ${
                    loading
                      ? "bg-gray-300 border-gray-400 text-gray-600 cursor-not-allowed"
                      : "hover:bg-red-800 border-red-800 hover:text-white text-red-800 cursor-pointer transition ease-in-out duration-300 hover:duration-500"
                  }
                `}
        >
          {loading ? "Submitting..." : "Submit"}
          {!loading && <BiSolidPaperPlane className="text-xl" />}
        </button>
      </div>
    </form>
  );
};

export default ContactForm;
